import { createContext, useContext } from 'react';

type BalanceReportExpandContextValue = {
  expanded: Record<string, boolean>;
  toggleRow: (id: string) => void;
};

const BalanceReportExpandContext = createContext<BalanceReportExpandContextValue>({
  expanded: {},
  toggleRow: () => undefined,
});

export const BalanceReportExpandContextProvider = BalanceReportExpandContext.Provider;

export function useBalanceReportExpandContext(): BalanceReportExpandContextValue {
  const context = useContext(BalanceReportExpandContext);

  if (!context) {
    throw new Error(
      'Can not `useBalanceReportExpandContext` outside of the `BalanceReportExpandContextProvider`',
    );
  }

  return context;
}
